var map = {
	"./alien.png": 37959,
	"./blank.png": 63826,
	"./bubblegum.png": 60356,
	"./doobie.png": 84338,
	"./face_mask.png": 2530,
	"./fish.png": 43691,
	"./grass.png": 45118,
	"./heartbeat.png": 77217,
	"./kiss.png": 20249,
	"./ninja.png": 6019,
	"./normal.png": 57265,
	"./robot.png": 4591,
	"./sharp_teeth.png": 94733,
	"./silk_shot.png": 38785,
	"./smiley.png": 91501,
	"./smirk.png": 43353,
	"./surprised.png": 11333,
	"./tongue.png": 33815,
	"./uwu.png": 2746,
	"./vampire.png": 66665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98697;